import { AvailableServices } from 'commons/types/DTO/commons'

import { AvailableServicesFormValue } from '../../../../types/forms'

export const mapAvailableServicesForm = (formValues: AvailableServicesFormValue): AvailableServices => ({
  ...formValues
})
